import React, { useReducer, useEffect } from "react";
import * as yup from "yup";
import { Form, Formik } from "formik";
import Modal from "react-bootstrap/Modal";
import {
  formInitialState,
  formReducer,
} from "../../../../../reducers/formReducer";
import FormErrorMessage from "../../../../UI/errorMessages/FormErrorMessage";
import CMSFormTextArea from "../../../../UI/forms/CMSFormTextArea";
import { Button } from "react-bootstrap";
import { ContainerLoading } from "../../../../UI/loading/ContainerLoading";
import axios from "../../../../../config/axios";
import { Store as toast } from "react-notifications-component";
import { toastNotification } from "../../../../../config/toastNotification";
import moduleConfig from "../../moduleConfig";
import CMSFormSelect from "../../../../UI/forms/CMSFormSelect";

const SubscriptionStatusModal = ({
  show,
  setShow,
  loadItem,
  item,
  id,
  status = "End",
}) => {
  const [formState, formDispatch] = useReducer(formReducer, formInitialState);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const onSubmit = async (data, resetForm) => {
    formDispatch({
      type: "FORM_SUBMISSION_REQUEST",
    });

    try {
      const res = await axios.post(`${moduleConfig.url}/deposit-return`, data);
      formDispatch({
        type: "FORM_SUBMISSION_SUCCESS",
        payload: res.data,
      });
      handleClose();
      toast.addNotification({
        ...toastNotification,
        title: "Success!",
        message: `Action done successfully.`,
        type: "success",
      });
      resetForm();
      formDispatch({
        type: "FORM_INITIAL_STAGE",
      });
      loadItem();
    } catch (error) {
      formDispatch({
        type: "FORM_SUBMISSION_FAILED",
        payload: error,
      });

      setTimeout(() => {
        formDispatch({
          type: "FORM_INITIAL_STAGE",
        });
      }, 5000);
    }
  };

  const getValidationSchema = () => {
    return yup.object({
      depositReturned: yup.string().required("Required"),
    });
  };

  const getInitialValues = () => {
    let returnObj = {
      subscriptionId: id,
      depositReturned: "1",
      depositReturnedMessage:"",
    };

    return returnObj;
  };

  return (
    <Formik
      initialValues={getInitialValues()}
      validationSchema={getValidationSchema()}
      enableReinitialize={true}
      validateOnChange={true}
      validateOnBlur={true}
      onSubmit={async (values, { resetForm }) => {
        onSubmit(values, resetForm);
      }}
    >
      {(form) => (
        <Modal show={show} onHide={handleClose}>
          {formState.isFormSubmitting && (
            <div className="overlay">
              <i className="fas fa-2x fa-sync-alt text-white fa-spin"></i>
            </div>
          )}

          {/* {(formState.isFormSubmitting) && <ContainerLoading />} */}
          <Form onSubmit={form.handleSubmit}>
            <Modal.Header closeButton>
              <Modal.Title>End Subscription</Modal.Title>
            </Modal.Header>

            <Modal.Body>
              {formState.hasSubmissionError && (
                <FormErrorMessage error={formState.formSubmissionError} />
              )}

              <CMSFormSelect
                name="depositReturned"
                label="Deposit Returned"
                form={form}
                required={true}
                options={[
                  { label: "Yes", value: "1" },
                  { label: "No", value: "0" },
                ]}
              />
                <CMSFormTextArea
                name="depositReturnedMessage"
                label="Deposit Returned Message"
                form={form}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
              <Button variant="primary" type="submit">
                Submit
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      )}
    </Formik>
  );
};

export default SubscriptionStatusModal;
